import { Get, Success } from "./Types"

let initialstate = {
    apidata:[],
    data:[
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :1,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYinBo",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :1,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYinBo",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :125,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            followers:"5",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :1200,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :17,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :18,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :1850,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :525,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            followers:"5",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :17,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :18,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :561,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :1596,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
        {
            id :1,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :17,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :18,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
    ],
    current:[
        
        {
            id :1,
            name:"Bvelyn",
            profileimg:"https://www.kindmeal.my/photos/member/14/14287-m.jpg",
            date:"11-Nov-2022",
            followers:"5",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist On this Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24550-47503-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :2,
            name:"YinYin",
            profileimg:"https://www.kindmeal.my/photos/member/23/23028-m.jpg",
            bgimg:"https://www.kindmeal.my/photos/member/23/23028-c.jpg",
            date:"11-Nov-2022",
            followers:"8",
            title:"Today’s salad. Having a salad today as I know I’m gonna have cooked food tomorrow at Malaysia VegFest.",
            img:"https://www.kindmeal.my/photos/moment/24/24560-47541-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24550-47507-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24550-47504-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24550-47505-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24550-47506-l.jpg",
        },
        {
            id :3,
            name:"FatJedi",
            profileimg:"https://www.kindmeal.my/photos/member/0/1-m.jpg",
            date:"13-Nov-2022",
            followers:"50",
            title:"Discovered this nice new cafe on KindMeal!",
            bgimg:"https://www.kindmeal.my/photos/member/0/1-c.jpg",
            img:"https://www.kindmeal.my/photos/moment/24/24597-47663-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24597-47664-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24597-47665-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24597-47666-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24597-47667-l.jpg",
        },
        {
            id :4,
            name:"JasonFong",
            profileimg:"https://www.kindmeal.my/photos/member/22/22038-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            followers:"25",
            title:"來這享用早午餐咯。有order了crispy chicken wrap, 香腸麵包和印尼友族rojak。這檔口在裡面counter旁邊哦",
            img:"https://www.kindmeal.my/photos/moment/24/24581-47607-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24581-47608-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24581-47609-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24581-47610-l.jpg",
            img4:"",
        },
        {
            id :5,
            name:"PiggyLoves",
            profileimg:"https://www.kindmeal.my/photos/member/10/10038-m.jpg",
            date:"10-Nov-2022",
            followers:"15",
            bgimg:"https://www.kindmeal.my/photos/member/10/10038-c.jpg",
            title:"Bought some vegetarian snacks during charity bazaar last Sunday at Ban Foo Buddhist Organisation PJ HQ.",
            img:"https://www.kindmeal.my/photos/moment/24/24576-47583-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24576-47584-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24576-47585-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24576-47586-l.jpg",
            img4:"",
        },
        {
            id :6,
            name:"CindyChang",
            followers:"150",
            profileimg:"https://www.kindmeal.my/photos/member/35/35238-m.jpg",
            title:"早餐在Puchong 剛开两个星期健康素食小炒在（大馬福建面茶餐室）年青小伙子炒的还不錯，路过的素友都去支持支持下为小老板加油加油",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-3.jpg",
            date:"12-Nov-2022",
            img:"https://www.kindmeal.my/photos/moment/24/24558-47536-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24558-47535-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24558-47537-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24558-47538-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24558-47539-l.jpg",
        },
        {
            id :7,
            name:"ChewLeng",
            profileimg:"https://www.kindmeal.my/photos/member/11/11540-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-5.jpg",
            title:"小炒RM7.00起，经济面RM2.50起 初一和十五有擂茶饭RM8.00起，糙米饭RM9.00 Vegetarian stall at PJ Permas Jaya Kopitiam",
            date:"06-Nov-2022",
            followers:"80",
            img:"https://www.kindmeal.my/photos/moment/24/24517-47396-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24517-47392-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24517-47393-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24517-47394-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24517-47395-l.jpg",
        },
        {
            id :8,
            name:"WeeChain",
            profileimg:"https://www.kindmeal.my/photos/member/22/22429-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-4.jpg",
            date:"08-Nov-2022",
            followers:"60",
            title:"Nissin 泰国素食激辣面和激辣龙虾面 Nissin Thai Vegetarian Spicy Instant Noodles and Chili Lobster Instant Noodles",
            img:"https://www.kindmeal.my/photos/moment/24/24532-47451-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24532-47452-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24532-47453-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24532-47454-l.jpg",
            img4:"",
        },
        {
            id :9,
            name:"GohSyLin",
            profileimg:"https://www.kindmeal.my/photos/member/32/32617-m.jpg",
            bgimg:"https://www.kindmeal.my/images/default_member_cover-2.jpg",
            title:"敢死隊去嘗試，結論還是材燒的比較香 女兒還要求要香蕉葉當盤子用，還好家四周鄰居都有香蕉樹",
            date:"07-Nov-2022",
            followers:"78",
            img:"https://www.kindmeal.my/photos/moment/24/24463-47202-l.jpg",
            img1:"https://www.kindmeal.my/photos/moment/24/24463-47203-l.jpg",
            img2:"https://www.kindmeal.my/photos/moment/24/24463-47204-l.jpg",
            img3:"https://www.kindmeal.my/photos/moment/24/24463-47205-l.jpg",
            img4:"https://www.kindmeal.my/photos/moment/24/24463-47206-l.jpg",
        },
    ]
}


let reducer=(state=initialstate,action)=>{
    if(action.type==Success){
        return {
            ...state,
            current:action.payload

        }
    }
    if(action.type==Get){
        return {
            ...state,
            apidata:action.payload
            
        }
    }
    return state
}

export {reducer}